import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
  })

export class CustomerService {

constructor(private http: HttpClient) { }

SubmitOnboardingForm(formData: FormData): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/add-onboarding`;
  return this.http.post<any>(apiURL, formData);
}

EditOnboardingForm(formData: FormData): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/update-onboarding`;
  return this.http.post<any>(apiURL, formData);
}

AddNewOfficer(data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/add-officers`;
  return this.http.post<any>(apiURL,data);
}

AddNewfactory(data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/add-offices`;
  return this.http.post<any>(apiURL,data);
}

AddNewBank(formData: FormData): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/add-bankdetails`;
  return this.http.post<any>(apiURL,formData);
}

AddEditOfficer(data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/update-officers`;
  return this.http.post<any>(apiURL,data);
}

AddEditfactory(data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/update-offices`;
  return this.http.post<any>(apiURL,data);
}

AddEditBank(formData: FormData): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/update-bankdetails`;
  return this.http.post<any>(apiURL,formData);
}

DeleteOfficer(data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/delete-officer`;
  return this.http.post<any>(apiURL,data);
}

Deletefactory(data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/delete-offices`;
  return this.http.post<any>(apiURL,data);
}

DeleteBank(data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/onboard/v1/delete-bankdetails`;
  return this.http.post<any>(apiURL,data);
}

PublishForm(Data: any): Observable<any> {
  const apiURL = `${environment.auth_url}/authentication/v1/publish-profile`;
  return this.http.post<any>(apiURL, Data);
}

}
